import { render, staticRenderFns } from "./addBoard.vue?vue&type=template&id=294971fa"
import script from "./addBoard.vue?vue&type=script&lang=js"
export * from "./addBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports